// extracted by mini-css-extract-plugin
export default {"container":"Tag_container__nyk2K","icon":"Tag_icon__8Nxhp","featureIcon":"Tag_featureIcon__tYvQp","feature":"Tag_feature__6vFnG"};